import { BaseModel } from './BaseModel';
import { Egg } from './Egg';
import { Node } from './Node';

export class Tag extends BaseModel {
    public id = '';
    public name = '';
    public slug = '';
    // Effective chip colour (enum brand colour for predefined tags, else the
    // tenant-chosen colour); null renders the neutral default.
    public color: string | null = null;
    public isPredefined = false;
    public nodesCount?: number;
    public eggsCount?: number;
    public serverTemplatesCount?: number;

    getRouteName() {
        return 'tag';
    }

    getRouteID() {
        return this.id.toString();
    }

    public get nodes(): Node[] {
        return this.getRelationship('nodes') || [];
    }

    public get eggs(): Egg[] {
        return this.getRelationship('eggs') || [];
    }
}
